import { Model } from 'app/model/backendmodel';
import { AdapterContext, ValueAdapter } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { FormatReadSettings } from 'app/model/pipeline/copysource/format-read-settings/format-read-settings';
import { FormatWriteSettings } from 'app/model/pipeline/copysink/format-write-settings/format-write-settings';
import { convertTypeToPlural } from 'app/model/pipeline/type.util';
import { merge } from 'lodash';

export async function convertFormatSettingsToResource(
    formatSettings: FormatReadSettings | FormatWriteSettings,
    result: {
        formatSettings?: Model.FormatReadSettings | Model.FormatWriteSettings;
    },
    context: AdapterContext
): Promise<void> {
    if (formatSettings == null) {
        return undefined;
    }
    const adapter = context.asyncAdapterFor(Metamodel.modelOf(formatSettings));
    if (adapter != null) {
        result.formatSettings = await adapter.toResource(formatSettings);
        if (formatSettings.raw) {
            const parsed = JSON.parse(formatSettings.raw);
            merge(result.formatSettings, parsed);
        }
    }
}

export async function convertFormatSettingsToModel(
    resource: Model.FormatReadSettings | Model.FormatWriteSettings,
    entity: {
        formatSettings?: FormatReadSettings | FormatWriteSettings;
    },
    context: AdapterContext
): Promise<void> {
    if (resource == null) {
        return;
    }
    resource.type = convertTypeToPlural(resource.type);
    const adapter = context.asyncAdapterFor(Metamodel.modelByName(resource.type));
    if (adapter != null) {
        entity.formatSettings = await adapter.toModel(resource, entity);
        entity.formatSettings.raw = JSON.stringify(
            await ValueAdapter.remainder(context, resource, Metamodel.modelOf(entity.formatSettings))
        );
    }
}
